/**
 * [緯度経度から2地点間の距離 (km) を計算する JavaScript - Qiita](https://qiita.com/kawanet/items/a2e111b17b8eb5ac859a)
 * @param lat1
 * @param lng1
 * @param lat2
 * @param lng2
 * @returns {number}
 */

export function geoDistance(lat1, lng1, lat2, lng2) {
  const rad = Math.PI / 180;
  lat1 *= rad;
  lng1 *= rad;
  lat2 *= rad;
  lng2 *= rad;
  return (
    6371 *
    Math.acos(
      Math.cos(lat1) * Math.cos(lat2) * Math.cos(lng2 - lng1) +
        Math.sin(lat1) * Math.sin(lat2)
    )
  );
}

export function isNearToArena(threshold, lat1, lng1, lat2, lng2) {
  return geoDistance(lat1, lng1, lat2, lng2) < threshold;
}

/**
 * 壁の前でなくても描きこめるか
 * @param cheat
 * @param env
 * @returns {boolean|*}
 */
export function checkCheat(cheat, env) {
  if (env === "production") return false;
  return cheat;
}

export async function getGeoPos() {
  return new Promise((resolve, reject) =>
    navigator.geolocation.getCurrentPosition(resolve, reject)
  );
}

/**
 * 近くならtrue。遠い or 位置情報使えないならfalse
 * @param threshold
 * @param lat1
 * @param lng1
 * @returns {Promise<unknown>}
 */
export async function checkGeo(threshold, lat1, lng1) {
  return new Promise(async (resolve, reject) => {
    await getGeoPos().then(
      position => {
        resolve(
          isNearToArena(
            threshold,
            lat1,
            lng1,
            position.coords.latitude,
            position.coords.longitude
          )
        );
      },
      e => {
        console.log("[GeoUtil] ", e);
        // alert(e.message + ", " + e.code);
        reject({err: e});
      }
    );
  });
}
